import * as React from "react";

import { useCurrentProjectContext } from "@v2/contexts/CurrentProjectContext";

function useCurrentProjectId() {
  const { projectId } = useCurrentProjectContext();
  return projectId;
}

export default useCurrentProjectId;
